import classNames from 'classnames'
import React from 'react'
import WhiteCopy from '@/assets/image/white-copy.png'
import GrayCopy from '@/assets/image/copy.svg'
import copy from 'copy-to-clipboard'
import { message, Tooltip } from 'antd'
import { cutStr } from '@/utils'

import styles from './index.module.less'
import { useTranslation } from 'react-i18next'
import { useGlobalStore } from '@/hoxStore/globalStore'

enum CopyIconType {
  White = 'white',
  Gray = 'gray',
}

interface AddressHashProps {
  data: string
  className?: string
  cutOption?: boolean | object
  textStyle?: React.CSSProperties
  handleJump?: false | (() => void) // 跳转
  copyIcon?: boolean | CopyIconType | React.ReactNode
  font_12?: boolean
}

function isReactNode(value: any): value is React.ReactNode {
  return React.isValidElement(value)
}

const AddressHash = ({
  className,
  data,
  cutOption,
  textStyle,
  handleJump,
  font_12,
  copyIcon = false,
}: AddressHashProps) => {
  const { curReponsive } = useGlobalStore()
  const { t } = useTranslation()
  const copyIconMap = {
    [CopyIconType.White]: WhiteCopy,
    [CopyIconType.Gray]: GrayCopy,
  }
  /**
   *  复制
   * */
  const handleCopy = (e: React.MouseEvent<HTMLSpanElement>) => {
    e.stopPropagation()
    copy(data)
    // 复制成功
    message.success(t('explorer_249'))
  }

  const clickJump = () => {
    if (handleJump) {
      handleJump()
    }
  }

  // 动态渲染icon
  const renderCopyIcon = () => {
    if (copyIcon === false || data === '-' || !data) return null
    if (isReactNode(copyIcon)) return copyIcon
    if (copyIcon === CopyIconType.White || copyIcon === CopyIconType.Gray) {
      return (
        // <span className={classNames(styles.imgWrap)}>

        // </span>
        <img
          className={classNames(styles.copy_img, styles[copyIcon], {
            copy_img_14: true,
          })}
          src={copyIconMap[copyIcon]}
          onClick={handleCopy}
        />
      )
    }
    return (
      <span className={styles.imgWrap}>
        <img
          className={classNames(styles.copy_img, styles['white'])}
          src={WhiteCopy}
          onClick={handleCopy}
        />
      </span>
    )
  }

  return (
    <>
      {data ? (
        <div className={classNames(styles.address_hash, className, 'address_hash_wrap', {})}>
          <span
            className={classNames({
              [styles.content]: true,
              text_align_left: true,
              [styles.address_hash_none]: data === '-',
            })}
            style={textStyle}
          >
            <Tooltip title={cutOption && data}>
              <span
                className={classNames({
                  [styles.content]: true,
                  common_link: handleJump,
                  [styles.cutOption_nowrap]: cutOption,
                  font_14: true,
                  font_12: font_12,
                })}
                style={textStyle}
                onClick={clickJump}
              >
                {cutOption
                  ? cutStr(
                      data,
                      curReponsive?.size === 'mobile' ? 5 : 6,
                      curReponsive?.size === 'mobile' ? 5 : 6,
                    )
                  : data}
              </span>
            </Tooltip>
            {renderCopyIcon()}
          </span>
        </div>
      ) : (
        '-'
      )}
    </>
  )
}

export default AddressHash
